<template>
  <v-btn
    class="settings"
    color="grey lighten-3"
    elevation="2"
    width="36"
    height="36"
    min-width="36"
    min-height="36"
    :to="to"
    :disabled="disabled"
  >
    <v-icon color="grey darken-1" class="material-icons-outlined">
      settings
    </v-icon>
  </v-btn>
</template>

<script>
export default {
  name: 'SettingsButton',
  props: {
    to: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
